import { useEffect, useState } from "react";
import { adminApi, errMsg } from "../api";
import { UploadButton } from "../components";
import { toast } from "../../components/ui/sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function MediaAdmin() {
  const [items, setItems] = useState([]);
  const load = () => adminApi.get("/admin/media").then((r) => setItems(r.data)).catch((e) => toast.error(errMsg(e)));
  useEffect(() => { load(); }, []);

  const remove = async (m) => {
    if (!window.confirm(`Delete ${m.filename}? Anything referencing it will break.`)) return;
    try { await adminApi.delete(`/admin/media/${m.id}`); toast.success("Deleted"); load(); }
    catch (e) { toast.error(errMsg(e)); }
  };

  const copy = (m) => {
    navigator.clipboard?.writeText(`${BACKEND_URL}${m.url}`);
    toast.success("URL copied");
  };

  return (
    <div data-testid="admin-media-page">
      <div className="adm-head">
        <div><h1>Media library</h1><div className="sub">Stored in the database (GridFS) — survives restarts and redeploys. Max 10 MB.</div></div>
        <UploadButton onUploaded={load} label="Upload file" testid="media-upload" />
      </div>
      <div className="adm-card" style={{ padding: 0, overflow: "auto" }}>
        <table className="adm-table">
          <thead><tr><th></th><th>Filename</th><th>Type</th><th>Size</th><th>Uploaded</th><th style={{ width: 170 }}></th></tr></thead>
          <tbody>
            {items.map((m) => (
              <tr key={m.id}>
                <td>{m.content_type?.startsWith("image/") ? <img className="thumb" src={`${BACKEND_URL}${m.url}`} alt="" /> : <span className="mono">FILE</span>}</td>
                <td>{m.filename}</td>
                <td className="mono">{m.content_type}</td>
                <td className="mono">{(m.size / 1024).toFixed(0)} KB</td>
                <td className="mono">{(m.created_at || "").slice(0, 10)}</td>
                <td>
                  <div style={{ display: "flex", gap: 6 }}>
                    <button className="adm-btn ghost sm" onClick={() => copy(m)}>Copy URL</button>
                    <button className="adm-btn danger sm" onClick={() => remove(m)}>Delete</button>
                  </div>
                </td>
              </tr>
            ))}
            {items.length === 0 && <tr><td colSpan={6} className="adm-empty">No uploads yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
